import React from 'react';
import { Trash2, Plus } from 'lucide-react';

interface Props {
  data: {
    invites: string[];
  };
  updateData: (data: Partial<typeof Props['data']>) => void;
  onSkip: () => void;
}

export const InviteTeam = ({ data, updateData, onSkip }: Props) => {
  const addInvite = () => {
    if (data.invites.length < 5) {
      updateData({ invites: [...data.invites, ''] });
    }
  };

  const removeInvite = (index: number) => {
    const newInvites = data.invites.filter((_, i) => i !== index);
    updateData({ invites: newInvites });
  };

  const updateInvite = (index: number, value: string) => {
    const newInvites = [...data.invites];
    newInvites[index] = value;
    updateData({ invites: newInvites });
  };

  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-2">
        Invite your team members
      </h2>
      <p className="text-center text-gray-600 mb-8">
        Send invite links via email. You can skip this for now.
      </p>

      <div className="space-y-4">
        {data.invites.map((email, index) => (
          <div key={index} className="flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => updateInvite(index, e.target.value)}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="colleague@company.com"
            />
            <button
              onClick={() => removeInvite(index)}
              className="p-2 text-gray-500 hover:text-red-500"
            >
              <Trash2 size={20} />
            </button>
          </div>
        ))}

        {data.invites.length < 5 && (
          <button
            onClick={addInvite}
            className="flex items-center gap-2 text-[#4B6BFB] hover:text-[#4B6BFB]/80"
          >
            <Plus size={20} />
            Add another
          </button>
        )}

        <button
          onClick={onSkip}
          className="block w-full text-center text-gray-500 hover:text-gray-700 mt-6"
        >
          Skip & go to dashboard
        </button>
      </div>
    </div>
  );
};